import { appendQuery, formatDate } from 'src/app/shared/utilities/route';

/**
 * Helper for serializing an object into an asp.net core web api compliant query string
 * @param object
 */
export function serializeToQueryString(object: object): string {
    if (object === null || object === undefined) {
        return '';
    }
    const params = toParamsArray(object);
    const queryString = params.reduce((acc, cur) => appendQuery(acc, cur), '');
    return queryString;
}

function serializeArray(value: any[], propertyPath: string): string[] {
    const arrayValues = value.map((val) => toParamsArray(val, propertyPath));
    return arrayValues.reduce((acc, val) => acc.concat(val), []);
}

function serializeObject(value: any, propertyPath: string): string[] {
    let strings = [];
    const keys = Object.keys(value);
    for (const key of keys) {
        const objectFieldValue = value[key];
        const actualKey = propertyPath ? `${propertyPath}.${key}` : key;
        const paramsForObjectValue = toParamsArray(objectFieldValue, actualKey);
        strings = strings.concat(paramsForObjectValue);
    }

    return strings;
}

function toParamsArray(value: any, propertyPath?: string): string[] {
    if (value === null) {
        return [];
    }

    if (value === undefined) {
        return [];
    }

    if (propertyPath === undefined) {
        propertyPath = '';
    }

    const serializableTypes = ['boolean', 'number', 'string', 'object'];
    const isValueSerializable = serializableTypes.indexOf(typeof value) > -1;
    if (!isValueSerializable) {
        return [];
    }
    let params: string[] = [];

    if (Array.isArray(value)) {
        const strings = serializeArray(value, propertyPath);
        params = params.concat(strings);
    }

    if (value instanceof Date) {
        params.push(`${propertyPath}=${formatDate(value)}`);
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
        const strings = serializeObject(value, propertyPath);
        params = params.concat(strings);
    }

    const primitiveSerializableTypes = ['string', 'number', 'boolean'];
    const isOfPrimitiveSerializableTypes = primitiveSerializableTypes.indexOf(typeof value) > -1;
    if (isOfPrimitiveSerializableTypes) {
        params.push(`${propertyPath}=${encodeURIComponent(value)}`);
    }

    return params;
}
